module.exports = __webpack_public_path__ + "img/partTest.67dbdcd5.png";